module.exports = __webpack_public_path__ + "static/media/Readines_Tool.020605ed.svg";